import EmblaCarousel from "embla-carousel"

export function carouselNextSlide(div, direction) {
  const emblaNode = document.querySelector(div)
  const options = { loop: false }
  const embla = EmblaCarousel(emblaNode, options)
  if (direction === 'next') {
    if (embla.canScrollNext()) {
      embla.scrollNext()
    }
  }
  if (direction === 'prev' && embla.canScrollPrev()) embla.scrollPrev()
}

window.carouselNextSlide = carouselNextSlide
